import type { ReactNode } from 'react';

export const symbol_sort_by_alpha: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m181-379-31 81q-3 8-10.5 13t-16.5 5q-16 0-24.5-13T96-320l139-342q3-8 10.5-13t16.5-5h23q9 0 16.5 5t10.5 13l138 342q6 14-2.5 27T423-280q-9 0-16.5-5.5T396-299l-31-80H181Zm20-52h144l-70-185h-4l-70 185Zm406 99h207q11 0 18.5 7.5T840-306q0 11-7.5 18.5T814-280H567q-8 0-13.5-5.5T548-299v-32q0-5 2-10t5-9l226-278H592q-11 0-18.5-7.5T566-654q0-11 7.5-18.5T592-680h226q8 0 14 6t6 14v32q0 5-2 10t-5 9L607-332ZM402-784q-5 0-7-4.5t2-8.5l72-72q5-5 11-5t11 5l72 72q4 4 2 8.5t-7 4.5H402Zm67 693-72-72q-4-4-2-8.5t7-4.5h156q5 0 7 4.5t-2 8.5l-72 72q-5 5-11 5t-11-5Z"
		/>
	</svg>
);
